import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ratio } from "../utils/index.js";

function computeShortestPath(graph, pathLength, startNode, endNode) {
  var matrix = /* @__PURE__ */new Map();
  var queue = /* @__PURE__ */new Set();
  queue.add(startNode);

  var _loop = function _loop(length) {
    var currentQueue = _toConsumableArray(queue.keys());

    queue.clear();
    currentQueue.forEach(function (node) {
      var accumulatedWeight = length > 0 ? matrix.get(node)[length][1] : 0;
      graph(node).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            neighbor = _ref2[0],
            weight = _ref2[1];

        var paths = matrix.get(neighbor);

        if (!paths) {
          paths = [];
          matrix.set(neighbor, paths);
        }

        var newWeight = accumulatedWeight + weight;
        var nextPath = paths[length + 1];

        if (!nextPath || nextPath[1] > newWeight && (nextPath[1] / newWeight > 1.0001 || node < nextPath[0])) {
          paths[length + 1] = [node, newWeight];
        }

        if (length < pathLength - 1 && neighbor !== endNode) {
          queue.add(neighbor);
        }
      });
    });
  };

  for (var length = 0; length < pathLength; length += 1) {
    _loop(length);
  }

  return matrix;
}

function reconstructShortestPath(matrix, pathLength, endNode) {
  var path = [endNode];

  for (var node = endNode, length = pathLength; length > 0; length -= 1) {
    var _matrix$get$length = _slicedToArray(matrix.get(node)[length], 1);

    node = _matrix$get$length[0];
    path.push(node);
  }

  return path.reverse();
}

function findShortestPathLengthN(graph, pathLength, startNode, endNode) {
  return reconstructShortestPath(computeShortestPath(graph, pathLength, startNode, endNode), pathLength, endNode);
}

function makeGetColumnNeighbors(photos, spacing, padding, targetColumnWidth, targetColumnHeight) {
  return function (node) {
    var results = [];
    var cutOffHeight = targetColumnHeight * 1.5;
    var height = targetColumnWidth / ratio(photos[node]) + 2 * padding;

    for (var i = node + 1; i < photos.length + 1; i += 1) {
      results.push([i, Math.pow(targetColumnHeight - height, 2)]);

      if (height > cutOffHeight || i === photos.length) {
        break;
      }

      height += targetColumnWidth / ratio(photos[i]) + spacing + 2 * padding;
    }

    return results;
  };
}

function buildColumnsModel(path, photos, spacing, padding, containerWidth, columnsGaps, columnsRatios) {
  var tracks = [];
  var totalRatio = columnsRatios.reduce(function (total, columnRatio) {
    return total + columnRatio;
  }, 0);

  var _loop2 = function _loop2(i) {
    var column = photos.map(function (photo, index) {
      return {
        photo: photo,
        index: index
      };
    }).slice(path[i], path[i + 1]);
    var adjustedGaps = columnsRatios.reduce(function (total, columnRatio, index) {
      return total + (columnsGaps[i] - columnsGaps[index]) * columnRatio;
    }, 0);
    var columnWidth = (containerWidth - (path.length - 2) * spacing - 2 * (path.length - 1) * padding - adjustedGaps) * columnsRatios[i] / totalRatio;
    tracks.push({
      photos: column.map(function (_ref3) {
        var photo = _ref3.photo,
            index = _ref3.index;
        return {
          photo: photo,
          index: index,
          width: columnWidth,
          height: columnWidth / ratio(photo)
        };
      }),
      variables: {
        adjustedGaps: adjustedGaps,
        columnRatio: columnsRatios[i]
      }
    });
  };

  for (var i = 0; i < path.length - 1; i += 1) {
    _loop2(i);
  }

  return {
    tracks: tracks,
    variables: {
      totalRatio: totalRatio
    }
  };
}

function computeColumnsModel(photos, spacing, padding, containerWidth, targetColumnWidth, columns) {
  var columnsGaps = [];
  var columnsRatios = [];

  if (photos.length <= columns) {
    var averageRatio = photos.length > 0 ? photos.reduce(function (acc, photo) {
      return acc + ratio(photo);
    }, 0) / photos.length : 1;

    for (var i = 0; i < columns; i += 1) {
      columnsGaps[i] = 2 * padding;
      columnsRatios[i] = i < photos.length ? ratio(photos[i]) : averageRatio;
    }

    return buildColumnsModel(Array.from({
      length: columns + 1
    }, function (_, index) {
      return Math.min(index, photos.length);
    }), photos, spacing, padding, containerWidth, columnsGaps, columnsRatios);
  }

  var targetColumnHeight = (photos.reduce(function (acc, photo) {
    return acc + targetColumnWidth / ratio(photo);
  }, 0) + spacing * (photos.length - columns) + 2 * padding * photos.length) / columns;
  var getNeighbors = makeGetColumnNeighbors(photos, spacing, padding, targetColumnWidth, targetColumnHeight);
  var path = findShortestPathLengthN(getNeighbors, columns, 0, photos.length);

  for (var _i = 0; _i < path.length - 1; _i += 1) {
    var column = photos.slice(path[_i], path[_i + 1]);
    columnsGaps[_i] = spacing * (column.length - 1) + 2 * padding * column.length;
    columnsRatios[_i] = 1 / column.reduce(function (acc, photo) {
      return acc + 1 / ratio(photo);
    }, 0);
  }

  return buildColumnsModel(path, photos, spacing, padding, containerWidth, columnsGaps, columnsRatios);
}

function computeColumnsLayout(photos, spacing, padding, containerWidth, columns) {
  var targetColumnWidth = (containerWidth - spacing * (columns - 1) - 2 * padding * columns) / columns;

  var _computeColumnsModel = computeColumnsModel(photos, spacing, padding, containerWidth, targetColumnWidth, columns),
      tracks = _computeColumnsModel.tracks,
      variables = _computeColumnsModel.variables;

  if (tracks.some(function (track) {
    return track.photos.some(function (_ref4) {
      var width = _ref4.width,
          height = _ref4.height;
      return width < 0 || height < 0;
    });
  })) {
    return columns > 1 ? computeColumnsLayout(photos, spacing, padding, containerWidth, columns - 1) : void 0;
  }

  return {
    tracks: tracks,
    spacing: spacing,
    padding: padding,
    containerWidth: containerWidth,
    variables: _objectSpread({
      columns: columns
    }, variables)
  };
}

export { computeColumnsLayout as default };